import React from "react";
import { connect } from "react-redux";
import SideNav from "components/layout-components/SideNav";
import MobileNav from "components/layout-components/MobileNav";
import HeaderNav from "components/layout-components/HeaderNav";
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import AppViews from "views/app-views";
import { Grid, Layout } from "antd";

import navigationConfig from "configs/NavigationConfig";
import { NAV_TYPE_TOP } from "constants/ThemeConstant";
import utils from "utils";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ navCollapsed, navType, location, direction }) => {
  const currentRouteInfo = utils.getRouteInfo(navigationConfig, location.pathname);
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = !screens.includes("lg");
  // Defensief: alleen expliciet "TOP" verbergt de sidebar, zodat ontbrekende/oude
  // navType-waarden in opgeslagen state de navigatie niet laten verdwijnen.
  const isNavSide = navType !== NAV_TYPE_TOP;
  const isNavTop = navType === NAV_TYPE_TOP;

  return (
    <Layout>
      <HeaderNav isMobile={isMobile} />
      {/*{isNavTop && !isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}*/}
      <Layout className="app-container">
        {isNavSide && !isMobile ? <SideNav routeInfo={currentRouteInfo} /> : null}
        <Layout className="app-layout" style={{ paddingLeft: 0, minHeight: "100vh" }}>
          <div className={`app-content ${isNavTop ? "layout-top-nav" : ""}`}>
            <PageHeader display={currentRouteInfo?.breadcrumb} title={currentRouteInfo?.title} />
            <Content>
              <AppViews />
            </Content>
          </div>
          <Footer />
        </Layout>
      </Layout>
      {isMobile && <MobileNav />}
    </Layout>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;
  return { navCollapsed, navType, locale };
};

export default connect(mapStateToProps)(React.memo(AppLayout));
